import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'whatwg-fetch';
import 'url-search-params-polyfill';

class TwitterLogin extends Component {


  // TODO: move it outside design component
  getHeaders() {
    const headers = Object.assign({}, this.props.customHeaders);
    headers['Content-Type'] = 'application/json';
    return headers;
  }

  getRequestToken() {
    var popup = this.openPopup();

    return window.fetch(this.props.requestTokenUrl, {
      method: 'POST',
      credentials: this.props.credentials,
      headers: this.getHeaders()
    }).then(response => {
      return response.json();
    }).then(data => {
      popup.location = `https://api.twitter.com/oauth/authenticate?oauth_token=${data.oauth_token}`;
      this.polling(popup);
    }).catch(error => {
      popup.close();
      return this.props.onFailure();
    });
  }

  openPopup() {
    const w = this.props.dialogWidth;
    const h = this.props.dialogHeight;
    const left = (screen.width/2)-(w/2);
    const top = (screen.height/2)-(h/2);

    return window.open('', '', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
  }

  polling(popup) {
    const polling = setInterval(() => {
      if (!popup || popup.closed || popup.closed === undefined) {
        clearInterval(polling);
        this.props.onFailure();
      }

      const closeDialog = () => {
        clearInterval(polling);
        popup.close();
      };

      try {
        if (!popup.location.hostname.includes('api.twitter.com') &&
              !popup.location.hostname == '') {
          if (popup.location.search) {
            const query = new URLSearchParams(popup.location.search);

            const oauthToken = query.get('oauth_token');
            const oauthVerifier = query.get('oauth_verifier');

            closeDialog();
            return this.verifyTwitterToken(oauthVerifier, oauthToken);
          } else {
            closeDialog();
            return this.props.onFailure();
          }


        }
      } catch (error) {
        // Ignore DOMException: Blocked a frame with origin from accessing a cross-origin frame.
        // A hack to get around same-origin security policy errors in IE.
      }
    }, 500);
  }

  verifyTwitterToken(oAuthVerifier, oauthToken) {
    const endpoint = `${this.props.verifyTokenUrl
    }?oauth_verifier=${oAuthVerifier
    }&oauth_token=${oauthToken}`;

    return window.fetch(endpoint, {
      method: 'POST',
      credentials: this.props.credentials
    })
      .then(response => response.json())
      .then(json => this.props.onSuccess(json))
      .catch(error => this.props.onFailure());
  }


  onButtonClick = () => {
    return this.getRequestToken();
  }

  render() {
    const twitterButton = React.createElement(
      this.props.tag, {
        onClick: this.onButtonClick,
        style: this.props.style,
        disabled: this.props.disabled,
        className: this.props.className,
      }, this.props.children
    );
    return twitterButton;
  }
}

TwitterLogin.propTypes = {
  tag: PropTypes.string,
  requestTokenUrl: PropTypes.string.isRequired,
  onFailure: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  dialogWidth: PropTypes.number,
  dialogHeight: PropTypes.number,
  credentials: PropTypes.oneOf(['omit', 'same-origin', 'include']),
  customHeaders: PropTypes.object,
};

TwitterLogin.defaultProps = {
  tag: 'button',
  disabled: false,
  dialogWidth: 600,
  dialogHeight: 400,
  credentials: 'same-origin',
  customHeaders: {}
};

export default TwitterLogin;
